import type { TemplateDefinition } from "./types";
import { T01, T02, T03, T04 } from "./templates-module1";
import { T05, T06, T07, T08 } from "./templates-module2";
import { T09, T10, T11, T12 } from "./templates-module3";
import { T13, T14, T15, T16 } from "./templates-module4";
import { T17, T18, T19, T20 } from "./templates-module5";
import { T21, T22, T23, T24 } from "./templates-module6";

export const TEMPLATES: TemplateDefinition[] = [
  T01, T02, T03, T04,
  T05, T06, T07, T08,
  T09, T10, T11, T12,
  T13, T14, T15, T16,
  T17, T18, T19, T20,
  T21, T22, T23, T24,
];

export const TEMPLATE_MAP: Record<string, TemplateDefinition> = Object.fromEntries(
  TEMPLATES.map((t) => [t.id, t]),
);

export function getTemplate(id: string): TemplateDefinition | undefined {
  return TEMPLATE_MAP[id];
}

export function getTemplatesByModule(moduleId: number): TemplateDefinition[] {
  return TEMPLATES.filter((t) => t.module === moduleId);
}
